module.exports = __webpack_public_path__ + "img/college.f462f34.png";